import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from "react-modal";
import { useDropzone } from "react-dropzone";
import s from '../styles/Photo_Editor.module.css';

const DEFAULT_IMAGE = "/vehicles/default_upload_foto.png"; // Дефолтное фото

const PhotoEditor = ({ vehicleId }) => {
    const [loading, setLoading] = useState(true);
  const [photos, setPhotos] = useState({});
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState({ key: null, index: null });
  

  // Загружаем фото при загрузке компонента
  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const response = await axios.get(`/photo/vehicle-photos/${vehicleId}`);
        console.log("📨 Ответ сервера:", response.data); 
setPhotos(response.data);
console.log("🖼️ После setPhotos, photos:", photos);
      } catch (error) {
        console.error("Ошибка загрузки фото", error);
    } finally {
        setLoading(false); // Завершаем загрузку
      }
    };

    fetchPhotos();
  }, [vehicleId]);

  const photoFields = [
    { key: "photo_3_4_front_left_url", label: "¾ спереди слева" },
    { key: "photo_vin_url", label: "VIN" },
    { key: "photo_dashboard_url", label: "приборная панель" },
    { key: "photo_front_url", label: "спереди" },
    { key: "photo_rear_url", label: "сзади" },
    { key: "photo_3_4_rear_right_url", label: "¾ сзади справа" },
    { key: "photo_engine", label: "Двигатель" },
  ];


    // Функция открытия модалки подтверждения
    const openDeleteModal = (key, index = null) => {
        setDeleteInfo({ key, index });
        setDeleteModalOpen(true);
      };
    
      // Функция закрытия модалки
      const closeDeleteModal = () => {
        setDeleteModalOpen(false);
        setDeleteInfo({ key: null, index: null });
      };
    
      // Функция удаления фото
      const confirmDelete = async () => {
        const { key, index } = deleteInfo;
        try {
          await axios.post(`/photo/delete-photo`, { vehicleId, key, index });
          if (key === "photo_defects_urls" && index !== null) {
            setPhotos((prev) => ({
              ...prev,
              photo_defects_urls: prev.photo_defects_urls.filter((_, i) => i !== index),
            }));
          } else {
            setPhotos({ ...photos, [key]: null });
          }
        } catch (error) {
          console.error("Ошибка удаления фото", error);
        } finally {
          closeDeleteModal(); // Закрываем модалку после удаления
        }
      };
    

  // Загрузка фото
  const handleFileChange = async (e, key) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("vehicle_id", vehicleId);
    formData.append(key, file);

    try {
      const response = await axios.post(`/photo/upload-photo`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setPhotos((prev) => ({ ...prev, [key]: response.data.files[key] }));
    } catch (error) {
      console.error("Ошибка загрузки фото", error);
    }
  };

  // Обработчик загрузки нескольких фото дефектов (Drag & Drop)
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/png": [".png", ".PNG"],
      "image/jpeg": [".jpg", ".jpeg", ".JPG", ".JPEG"],
      "image/gif": [".gif", ".GIF"],
      "image/webp": [".webp", ".WEBP"],
      "image/heic": [".heic", ".HEIC"] // Добавляем HEIC
    },
    multiple: true,
    onDrop: async (acceptedFiles) => {
      const formData = new FormData();
      formData.append("vehicle_id", vehicleId);
      acceptedFiles.forEach((file) => formData.append("photo_defects", file));

      try {
        const response = await axios.post(`/photo/upload-photo`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        setPhotos((prev) => ({
          ...prev,
          photo_defects_urls: [...(prev.photo_defects_urls || []), ...response.data.defects],
        }));
      } catch (error) {
        console.error("Ошибка загрузки фото дефектов", error);
      }
    },
  });

  const openModal = (url) => {
    setSelectedPhoto(url);
    setModalOpen(true);
  };

  photoFields.forEach(({ key }) => {
    console.log(`🔹 ${key}:`, photos[key]);
  });

  useEffect(() => {
    console.log("💡 photos изменился:", photos);
  }, [photos]);
  

  return (
    <div className={s.photoEditor}>

      {/* Показ загрузки, пока данные не пришли */}
      {loading ? (
        <div className={s.loader}>Загрузка...</div>
      ) : (
        <>
          {/* Основные фото */}
          <div className={s.photoGrid}>
            {photoFields.map(({ key, label }) => (
              <div key={key} className={s.photoCard}>
                <h3 className={s.photoLabel}>{label}</h3>
                <div className={s.photoCard_div_with_close}>
                  <img
                    src={photos[key] ? `${process.env.PUBLIC_URL}/vehicles/${photos[key]}` : DEFAULT_IMAGE}
                    alt={label}
                    className={s.photo}
                    onClick={() => {
                      if (photos[key]) {
                        openModal(`${process.env.PUBLIC_URL}/vehicles/${photos[key]}`);
                      } else {
                        document.getElementById(`file-input-${key}`).click();
                      }
                    }}
                  />
                  {photos[key] && (
                    <button onClick={() => openDeleteModal(key)} className={s.deleteButtonSmall_all}>
                      X
                    </button>
                  )}
                </div>

                <div className={s.buttonGroup}>
                  {/* Скрытый input, который вызывается программно */}
                  <input
                    type="file"
                    id={`file-input-${key}`}
                    style={{ display: "none" }}
                    onChange={(e) => handleFileChange(e, key)}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Блок фото дефектов */}
          <h3 className={s.photoEditorTitle}>Фото дефектов</h3>

          <div className={s.defectGrid}>
            {photos.photo_defects_urls?.length > 0 ? (
              photos.photo_defects_urls.map((url, index) => (
                <div key={index} className={s.defectPhotoWrapper}>
                  <img
                    src={`${process.env.PUBLIC_URL}/vehicles/${url}`}
                    alt={`Дефект ${index + 1}`}
                    className={s.defectPhoto}
                    onClick={() => openModal(`${process.env.PUBLIC_URL}/vehicles/${url}`)}
                  />
                  <button
                    onClick={() => openDeleteModal("photo_defects_urls", index)}
                    className={s.deleteButtonSmall}
                  >
                    X
                  </button>
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
          <div {...getRootProps()} className={s.dropzone}>
            <input {...getInputProps()} />
            <p className={s.defectPhotoUpload_p}>Перетащите файлы сюда или кликните для загрузки дефектов</p>
          </div>
        </>
      )}

      {/* Модальное окно */}
      <Modal 
        isOpen={modalOpen} 
        onRequestClose={() => setModalOpen(false)} 
        className={s.modalContent} 
        overlayClassName={s.openphoto}
        appElement={document.getElementById("root")}
      >
        <div className={s.modalWrapper}>
          <button onClick={() => setModalOpen(false)} className={s.closeButton}>
            Закрыть
          </button>
          {selectedPhoto && <img src={selectedPhoto} alt="Просмотр фото" className={s.modalImage} />}
        </div>
      </Modal>

      {/* Модальное окно подтверждения */}
      <Modal
        isOpen={deleteModalOpen}
        onRequestClose={closeDeleteModal}
        className={s.modalContentDelete}
        overlayClassName={s.openphotoDelete}
        appElement={document.getElementById("root")}
      >
        <h2 className={s.modalTitleDelete}>Удалить фото?</h2>
        <p className={s.modalTextDelete}>Вы уверены, что хотите удалить это фото?</p>
        <div className={s.buttonGroupDelete}>
          <button onClick={confirmDelete} className={s.confirmButtonDelete}>
            Да, удалить
          </button>
          <button onClick={closeDeleteModal} className={s.cancelButtonDelete}>
            Отмена
          </button>
        </div>
      </Modal>
    </div>
);

};

export default PhotoEditor;
